export default __webpack_public_path__ + "static/media/portfolio-116.d63dd0c5.jpg";